import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={19} height={19} {...props}>
      <Path
        d="M18.449 1.29a1 1 0 010 1.414l-7.034 7.034 7.046 7.046a1 1 0 010 1.414l-.522.521a1 1 0 01-1.414 0L9.48 11.673l-7.034 7.034a1 1 0 01-1.414 0l-.524-.524a1 1 0 010-1.414L7.54 9.735.496 2.69a1 1 0 010-1.415l.52-.52a1 1 0 011.415 0L9.477 7.8 16.51.766a1 1 0 011.415 0l.524.524z"
        fill="#555559"
        fillRule="evenodd"
      />
    </Svg>
  );
}

const CloseIcon = React.memo(SvgComponent);
export default CloseIcon;
